import { Box, Button, VStack, Heading, Span } from '@bpba/ui-components';
import React, { useState } from 'react';
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';


import { useMutation } from '@apollo/client';

import { Mutations } from '../rest/Mutations';

import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { Result } from './Result';
import { ResultExito } from './ResultExito';
import { ResultError } from './ResultError';
import { CuentasFALApiRQ } from '../rest/models/CuentasFALApiRQ';
import { CuentasFAL } from '../rest/models/CuentasFAL';
import { postCuentasFAL } from '../rest/mutations/postCuentasFAL';
import { postEsClienteCuentasFAL } from '../rest/mutations/postEsClienteCuentasFAL';
import { ValidarCuitFALRQ } from '../rest/models/ValidarCuitFALRQ';
import ComboSucursales from './ComboSucursales';

export const ComponenteCuentasFAL: React.FC = () => {

    const { register, handleSubmit, control, setValue, formState: { errors }, reset } = useForm<CuentasFAL>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            sucursal: ""

        }
    });
    const REQUIRED_FIELD = "Campo requerido.";
    const numberValidator = /^\d+$/;
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;




    const [postValidarCuitApi, { loading: loadingValidarCuit }] = useMutation<Mutations>(postEsClienteCuentasFAL);
    const [postCuentasFALAPI, { loading: loadingMutation }] = useMutation<Mutations>(postCuentasFAL);
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<string>("");
    
    const [sucursalCliente, setSucursalCliente] = useState<number>(0);
    

    const [razonSocialCliente, setRazonSocialCliente] = useState<string>("");

    const [cuitValidado, setCuitValidado] = useState<boolean>(false);
    const [showFullForm, toggleFullForm] = useState<boolean>(false);



    const [servicioOk, setServicioOk] = useState<boolean>(false);


    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');

    const { executeRecaptcha } = useGoogleReCaptcha();





    const ValidarCuit = async (data: CuentasFAL) => {


        const token = executeRecaptcha && (await executeRecaptcha('ValidarCuit'));
        let datos: ValidarCuitFALRQ = {
            "cuit": data.cuit.toString(),
            "googleToken": token,
            "sistema": "cuentasFAL",
            "linea": ""
        }


        postValidarCuitApi({ variables: { input: datos } }).then(response => {
            
            if (response.data?.esClienteCuentasFAL) {

                setValue("nombreyApellido", response.data.esClienteCuentasFAL.razonSocial);
                setRazonSocialCliente(response.data.esClienteCuentasFAL.razonSocial);
                if (response.data.esClienteCuentasFAL.sucursal !== -1) {
                    setSucursalCliente(response.data.esClienteCuentasFAL.sucursal);
                    setValue("sucursal",response.data.esClienteCuentasFAL.sucursal.toString());
                    toggleFullForm(true);
                    setCuitValidado(true);
                }
            } else {
                setServicioOk(true);
                setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
            }
        }).catch((e: any) => {
            if (e.networkError.statusCode === 409) {
                //entiendo que el cuit no es cliente entonces lo dejo elegir sucursal y que llene sus datos
                setCuitValidado(true);
                toggleFullForm(true);

            } else {

                setServicioOk(false);
                setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
            }
        })
    }

    const onSubmit: SubmitHandler<CuentasFAL> = async (data: CuentasFAL) => showFullForm ? SubmitForm(data) : ValidarCuit(data);

    const SubmitForm: SubmitHandler<CuentasFAL> = async (data: CuentasFAL) => {


        const token = executeRecaptcha && (await executeRecaptcha('ValidarCuit'));
        let datos: CuentasFALApiRQ = {
            "googleToken": token,
            "razonSocial": data.nombreyApellido,
            "cuit": data.cuit.toString(),
            "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
            "localidad": "-",
            "email": data.email,
            "sucursal": Number(data.sucursal),
            "condicionImpositiva": "0",
            "origenSolicitud": origenSolicitud === null ? "" : origenSolicitud
        };
        await postCuentasFALAPI({ variables: { input: datos } }).then((response: any) => {
            
            if (response !== null || response !== undefined) {
                setServicioOk(true);
                if (response.data.CuentasFALApiRQ.resultado === "ok") {
                    setMensajeRtaServicio("Solicitud creada con éxito.En los próximos días nos contactaremos con vos.");

                } else if (response.data.CuentasFALApiRQ.error.toUpperCase().includes("ya tiene una solicitud".toUpperCase())) {

                    setMensajeRtaServicio(response.data.CuentasFALApiRQ.error);

                } else {
                    setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                }
            } else {

                setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");

            }


        }).catch(() => {

            setServicioOk(false);
            setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
        });





    }
    const handleReset = () => {
        reset({});
        window.location.reload();
    };
    if (loadingMutation || loadingValidarCuit) return <SpinnerCajas />;
    if (servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultExito message={mensajeRtaServicio}></ResultExito>
        </Result>
    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>

    );
    return (

        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>


                    {!cuitValidado ?

                        (<>
                            <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                Datos Generales
                            </Heading>

                            <VStack mt={"20px"}>
                                <input {...register(`cuit`, { required: REQUIRED_FIELD, minLength: { value: 11, message: "Debe tener al menos 11 dígitos" }, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} maxLength={11} name='cuit' placeholder='CUIT' type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.cuit ? "* " + errors.cuit.message : ""}</Span>
                            </VStack>
                            <Button type="submit" variant="secondary" py={"10px !important"}>Validar</Button>

                        </>)
                        : (<>
                            <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                Datos Generales
                            </Heading>
                            <VStack mt={"20px"}>

                                <input {...register(`cuit`, { required: REQUIRED_FIELD, minLength: { value: 11, message: "Debe tener al menos 11 dígitos" }, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} maxLength={11} name='cuit' type={"text"} defaultValue={""} placeholder='CUIT' disabled />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.cuit ? "* " + errors.cuit.message : ""}</Span>
                            </VStack>
                            {!razonSocialCliente ?

                                (<VStack mt={"20px"}>

                                    <input {...register(`nombreyApellido`, { required: REQUIRED_FIELD })} maxLength={25} name='nombreyApellido' type={"text"} placeholder='Nombre y Apellido' />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombreyApellido ? "* " + errors.nombreyApellido.message : ""}</Span>
                                </VStack>) :
                                (<VStack mt={"20px"}>
                                    <input {...register(`nombreyApellido`, { required: REQUIRED_FIELD, maxLength: razonSocialCliente?.length })} name='nombreyApellido' type={"text"} value={razonSocialCliente} placeholder='Nombre y Apellido' disabled />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombreyApellido ? "* " + errors.nombreyApellido.message : ""}</Span>
                                </VStack>)}



                            <VStack mt={"20px"}>
                                <input type={'text'} {...register("email", { required: REQUIRED_FIELD, maxLength: 100, pattern: { value: mailValidator, message: "Formato del correo electrónico inválido ejemplo: juana@mail.com" } })} name="email" placeholder='Correo electrónico' maxLength={100} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                            </VStack>

                            <VStack mt={"20px"}>
                                <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                    Teléfono de contacto
                                </Span>
                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Área: ejemplo 011' maxLength={5} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                                    </VStack>
                                    <VStack>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Número: fijo / cel sin el 15' maxLength={14} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                                    </VStack>
                                </VStack>
                            </VStack>


                           {  <Controller
                                control={control}
                                name="sucursal"
                                rules={{ required: true }}
                                render={({ field }) => {
                                    return <ComboSucursales onChangeValue={(e) => { field.onChange(e) }} titulo={"Sucursal donde querés finalizar el trámite"} sucursalCliente={sucursalCliente} />
                                }}
                            /> }

                            <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>
                        </>)

                    }

                </form>
            </VStack >

        </Box >

    )

};


